module.exports = __webpack_public_path__ + "static/media/Disconnected_User.dc7deaee.png";